import { noop } from 'lodash';
import { SignatureSingleActionProps } from 'components/tables/data/signature/types';
import { Menu, Tooltip } from '@mantine/core';
import { IconSignature } from '@tabler/icons-react';
import { useFinishSigningModal } from 'components/modals/finish-signing-modal/FinishSigningModalProvider';
import panic from 'errors/panic';
import Button from 'components/Button';
import ActionIcon from 'components/ActionIcon';

/**
 * Sign action for signatures.
 */
export default function SignAction({ signature, onStatusChange = noop, kind }: SignatureSingleActionProps) {
  const { finishSigningModal } = useFinishSigningModal();

  /**
   * Opens the modal to show all revisions with the same kepMessageUuid
   * and allows the user to continue signing.
   */
  const openFinishSigningModal = () => {
    if (!signature.kepMessageUuid) {
      panic(new Error('No kepMessageUuid found for signature'));
      return;
    }

    finishSigningModal({
      kepMessageUuid: signature.kepMessageUuid,
      message:
        'Podpisová správa už bola odoslaná do systému BrainIT. Pre dokončenie podpisovania budete presmerovaný do ich webového portálu.',
    });
  };

  if (kind === 'action-icon') {
    return (
      <Tooltip label="Podpísať" events={{ hover: true, focus: true, touch: true }}>
        <ActionIcon variant="secondary" size="md" onClick={openFinishSigningModal} disabled={!signature.kepSignUrl}>
          <IconSignature stroke={1.5} size={24} />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (kind === 'button') {
    return (
      <Button
        size="md"
        onClick={openFinishSigningModal}
        leftIcon={<IconSignature stroke={1.5} size={24} />}
        variant="secondary"
        disabled={!signature.kepSignUrl}
        w={128}
      >
        Podpísať
      </Button>
    );
  }

  return (
    <Menu.Item
      color="gray.8"
      onClick={openFinishSigningModal}
      icon={<IconSignature stroke={1.5} size={24} />}
      disabled={!signature.kepSignUrl}
    >
      Podpísať
    </Menu.Item>
  );
}
